import React from 'react';
import PropTypes from 'prop-types';
import BaseLayout from 'base/layouts/Layout';
import { SIX } from 'base/constants/grid';

const layoutPadding = {
  pt: SIX
};

class LocationDetailPageLayout extends React.Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]).isRequired
  };
  render() {
    return (
      <BaseLayout hideMobileStickyCtaFooter layoutPadding={layoutPadding}>
        {this.props.children}
      </BaseLayout>
    );
  }
}

export default LocationDetailPageLayout;
